export class RegisterOfBenefactorsEventType {

	static STEPS = {
		BENEFACTOR_ADD: {
			BENEFACTOR_ADD: 'BENEFACTOR_ADD',
			BENEFACTOR_DATA: 'BENEFACTOR_DATA',
			BENEFACTOR_CONFIRMATION: 'BENEFACTOR_CONFIRMATION',
		},
		BENEFACTOR_LIST: 'BENEFCTOR_LIST'
	};


	static BENEFACTOR = {
		SEND_DATA: 'SEND_DATA',
		CONFIRM_DATA: 'CONFIRM_DATA'
	};

	static ERROR = 'BENEFACTOR_ERROR';
	static BUTTONS = 'BENEFACTOR_BUTTONS';

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/register-of-benefactors/register-of-benefactors.event.type.ts